/* eslint-disable no-shadow */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext } from 'providers/GlobalProvider';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import DBModuleHeaderLayout from 'components/Common/Layouts/DBProductsModuleHeaderLayout';
import ProductResults from 'components/BiteDB/Modal/EditProduct';
import { getProductById } from 'api/bitedb/products/products.service';

const Product: React.FC = (props: any) => {
  const { cur_user } = useContext(GlobalContext);
  const history = useHistory();
  const { id } = useParams<{ id: string }>();

  const [userHasMonitor, setUserHasMonitor] = useState(true);
  const [isCheckingSubscription, setIsCheckingSubscription] = useState(true);

  const requiredTiers = ['business', 'enterprise'];

  const checkSubscription = async () => {
    if (cur_user.quickcodeOnly) {
      setUserHasMonitor(true);
      setIsCheckingSubscription(false);
      return;
    }
    try {
      if (
        requiredTiers.some((role) =>
          cur_user.selected_team?.attributes?.tier.includes(role),
        )
      ) {
        setUserHasMonitor(true);
        setIsCheckingSubscription(false);
        return;
      }
      if (requiredTiers.includes(cur_user.license)) {
        setUserHasMonitor(true);
        setIsCheckingSubscription(false);
        return;
      }
    } finally {
      setIsCheckingSubscription(false);
    }
  };

  useEffect(() => {
    if (cur_user.selected_team) {
      checkSubscription();
    }
  }, [cur_user.selected_team]);

  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  // Get product data from location state
  const [productData, setProductData] = useState<any>(null); // Get product data from location state

  useEffect(() => {
    const fetchData = async () => {
      // Check if there's product data in the location state (passed from another page)
      if (history.location && history.location.state) {
        const state = history.location.state as {
          objectData?: any;
          tabState?: string;
        };
        if (state.objectData) {
          setProductData({
            ...state.objectData,
            type: 'products',
          });
        }
      } else if (id) {
        const product = await getProductById(id);
        setProductData({
          ...product,
          type: 'products',
        });
      }
    };
    fetchData();
  }, [id]);

  return (
    <DBModuleHeaderLayout
      title={
        productData?.name && productData?.name !== ''
          ? productData?.name
          : productData?.hts_code && productData?.hts_code !== ''
          ? productData?.hts_code
          : 'Product'
      }
      databaseId={productData?.database_id}
      databaseName={productData?.database_name}
      hubLabel='BITE DB'
      hubTo='/bite-db/entities'
    >
      {productData ? (
        <ProductResults supplier={productData} />
      ) : (
        <div className='modal-content-header'>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '50px',
            }}
          >
            <div className='loading-spinner'>Loading product details...</div>
          </div>
        </div>
      )}
    </DBModuleHeaderLayout>
  );
};

export default Product;
